import { render, staticRenderFns } from "./chanelDonut.vue?vue&type=template&id=6bd47a78&"
import script from "./chanelDonut.vue?vue&type=script&lang=js&"
export * from "./chanelDonut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports